import { Action } from '@reduxjs/toolkit';
import { from, Observable } from 'rxjs';
import { catchError, filter, mergeMap, withLatestFrom } from 'rxjs/operators';

import { RootState } from 'app/redux/rootReducer';

import {
  updateProductTourViewedStart,
  updateProductTourViewedSuccess,
  updateProductTourViewedFailure,
} from './productTourSlice';
import { updateDashboardActivityRequest } from 'features/entities/entitiesRequests';

export const updateProductTourViewedEpic = (
  action$: Observable<Action>,
  state$: Observable<RootState>
) =>
  action$.pipe(
    filter(updateProductTourViewedStart.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      from(updateDashboardActivityRequest(action.payload)).pipe(
        mergeMap(() => [updateProductTourViewedSuccess()]),
        catchError((error: Error) => [updateProductTourViewedFailure({ error: error.message })])
      )
    )
  );
